import copy from 'copy-to-clipboard';

export enum CopiedFrom {
    NONE = 'NONE',
    LINK = 'LINK',
    HTML = 'HTML',
}

export const copyDashboardLink = (from: CopiedFrom, dashboardName: string, linkedUrl?: string): void => {
    if (linkedUrl) {
        if (from === CopiedFrom.LINK) {
            copy(linkedUrl);
        } else if (CopiedFrom.HTML) {
            copy(`<iframe src="${linkedUrl}" height="100%" width="100%" title="${dashboardName}"></iframe>`);
        }
    }
};
